import { useState } from 'react';
import { Link } from 'react-router-dom';
import EntryScreen from './components/EntryScreen';
import BasicInfoForm from './components/BasicInfoForm';
import OtpScreen from './components/OtpScreen';
import ProfileWizard from './components/ProfileWizard';
import ApprovalWaiting from './components/ApprovalWaiting';
import IncompleteProfile from './components/IncompleteProfile';
import ExtraInfo from './components/ExtraInfo';
import Suspended from './components/Suspended';
import Banned from './components/Banned';

type Screen =
  | 'entry'
  | 'basic'
  | 'otp'
  | 'profile'
  | 'waiting'
  | 'incomplete'
  | 'extra'
  | 'suspended'
  | 'banned';

interface BasicInfoData {
  name: string;
  phone: string;
  city: string;
  gender: string;
  kvkk: boolean;
  whatsappConsent: boolean;
}

const defaultBasicInfo: BasicInfoData = {
  name: '',
  phone: '',
  city: '',
  gender: '',
  kvkk: false,
  whatsappConsent: false,
};

export default function TherapistRegister() {
  const [screen, setScreen] = useState<Screen>('entry');
  const [basicInfo, setBasicInfo] = useState<BasicInfoData>(defaultBasicInfo);

  return (
    <div className="min-h-screen bg-off-white">
      {/* Minimal Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100">
        <div className="w-full px-4 md:px-8">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 text-deep-navy-500 font-bold text-lg tracking-tight"
            >
              <span className="w-8 h-8 rounded-lg bg-dark-teal-500 flex items-center justify-center text-white text-sm font-bold">
                S
              </span>
              <span>SpaProBridge</span>
            </Link>
            <span className="text-xs font-medium text-gray-400 hidden sm:block">
              Terapist Kayıt
            </span>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="pt-24 pb-16 px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          {screen === 'entry' && <EntryScreen onStart={() => setScreen('basic')} />}

          {screen === 'basic' && (
            <BasicInfoForm
              data={basicInfo}
              onChange={setBasicInfo}
              onSubmit={() => setScreen('otp')}
            />
          )}

          {screen === 'otp' && (
            <OtpScreen
              phone={basicInfo.phone}
              onVerify={() => setScreen('profile')}
              onChangePhone={() => setScreen('basic')}
              onResend={() => {}}
            />
          )}

          {screen === 'profile' && (
            <ProfileWizard onComplete={() => setScreen('waiting')} />
          )}

          {screen === 'waiting' && (
            <ApprovalWaiting onCheckStatus={() => setScreen('suspended')} />
          )}

          {screen === 'incomplete' && (
            <IncompleteProfile onComplete={() => setScreen('profile')} />
          )}

          {screen === 'extra' && (
            <ExtraInfo onSubmit={() => setScreen('waiting')} />
          )}

          {screen === 'suspended' && (
            <Suspended onSupport={() => setScreen('extra')} />
          )}

          {screen === 'banned' && <Banned />}
        </div>

        {/* Dev navigation for preview — remove in production */}
        <div className="mt-12 flex flex-wrap gap-2 justify-center">
          {(['entry', 'basic', 'otp', 'profile', 'waiting', 'incomplete', 'extra', 'suspended', 'banned'] as Screen[]).map((s) => (
            <button
              key={s}
              onClick={() => setScreen(s)}
              className={`px-3 py-1.5 rounded-full text-[10px] font-medium transition-colors cursor-pointer ${
                screen === s
                  ? 'bg-dark-teal-500 text-white'
                  : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
              }`}
            >
              {s}
            </button>
          ))}
        </div>
        <p className="text-[10px] text-gray-300 text-center mt-2">
          Geliştirici önizleme: ekranlar arası geçiş butonları
        </p>
      </main>
    </div>
  );
}